import readersactivity1 from "../../../assets/CampuLifeImages/readersactivity1.jpg"
import readersactivity2 from "../../../assets/CampuLifeImages/readersactivity2.jpg"
import readersactivity3 from "../../../assets/CampuLifeImages/readersactivity3.jpg"
import readersactivity4 from "../../../assets/CampuLifeImages/readersactivity4.jpg"
import ExtenStudClubGrievPage from '../../CampusSharedComponent/CampusDynamicPages/CampusExtenStudClubGrievDynamicPage/ExtenStudClubGrievPage'
import readersbanner from "../../../assets/CampuLifeImages/readersbanner.jpg"

const Reader = () => {

  const data =
  {
    name: "reader",
    viewmore: "true",
    hover: true,
    viewless: "true",
    pagename: "Reader's Club",
    title: "Reader's Club Activities",
    contentImg: readersbanner,
    para: "“The Reader’s Club aims to develop reading habits and information literacy skills among students. It engages students in a variety of cultural and creative activities related to book reading.”",
    paraobjective: "Objectives :",
    objectivepoints: ["To cultivate regular reading habits among students.", "To enhance information literacy and research skills.", "To encourage critical thinking and discussion through book-related activities.", "To expose students to diverse cultural and creative experiences centered around reading.", "To foster a love for literature and lifelong learning."],
    fourhover: true
  }


  const hoverContent = [
    { img: readersactivity1, para1: "Event @NICAS by Dept of English, Literary Association Program in excellent manner.", para2: "March 14, 2024" },
    { img: readersactivity2, para1: "Event @NICAS by Dept of English, Literary Association Program in excellent manner.", para2: "March 14, 2024" },
    { img: readersactivity3, para1: "Event @NICAS by Dept of English, Literary Association Program in excellent manner.", para2: "March 14, 2024" },
    { img: readersactivity4, para1: "Event @NICAS by Dept of English, Literary Association Program in excellent manner.", para2: "March 14, 2024" }
  ]

  return (
    <>
      <ExtenStudClubGrievPage data={data} hoverContent={hoverContent} />
    </>
  )
}

export default Reader